import React, { useState, useEffect } from 'react'
import { Col, Input, List, Modal, Popconfirm, Row, Tooltip } from 'antd'
import Button from 'antd-button-color'
import { SettingFilled, CaretRightFilled, CaretLeftFilled, SaveFilled, ShareAltOutlined } from '@ant-design/icons'
import TournamentProperties from './TournamentProperties'
import { useAuth0 } from '@auth0/auth0-react'
import { getTournament, shareTournament } from '../../../shared/restClient'
import _ from 'lodash'

const ShareTournament = (props) => {
  const { user } = useAuth0()
  const [users, setUsers] = useState([])
  const [email, setEmail] = useState('')

  useEffect(() => {
    if (props?.tournament?.users) {
      const validUsers = props?.tournament?.users?.filter(f => f !== user.email)
      setUsers(validUsers)
    }
  }, [props.tournament, user])

  const handleDelete = (email) => {
    const newUsers = props?.tournament?.users?.filter(f => f !== email)
    setUsers(users.filter(f => f !== email))
    props.onShare(newUsers)
  }

  const handleAdd = () => {
    if (!users.some(item => item === email) && email !== user.email) {
      const newUsers = _.cloneDeep(props?.tournament?.users)
      const updatedUsers = _.cloneDeep(users)
      newUsers.push(email)
      updatedUsers.push(email)

      setUsers(updatedUsers)
      setEmail('')
      props.onShare(newUsers)
    }
  }

  const handleOnChange = (e) => {
    const { value: inputValue } = e.target

    setEmail(inputValue)
  }

  return (
    <div>
      <Row>
        <Col span={20}>
          <Input placeholder='discord / google email' onChange={handleOnChange} />
        </Col>
        <Col span={4} style={{ textAlign: 'right', paddingRight: '10px' }}>
          <Button key='list-delete' shape='round' onClick={() => handleAdd()} type='success'>add</Button>
        </Col>
      </Row>
      <List
        itemLayout='horizontal'
        dataSource={users}
        renderItem={(item) => {
          return (
            <List.Item
              actions={[
                <Button key='list-delete' shape='round' onClick={() => handleDelete(item)} type='danger'>delete</Button>
              ]}
            >
              <List.Item.Meta
                title={item}
              />
            </List.Item>
          )
        }}
      />
    </div>
  )
}

const TournamentMenuBar = (props) => {
  const [isTournamentPropertiesModalVisible, setTournamentPropertiesModalVisible] = useState(false)
  const [isShareTournamentModalVisible, setIsShareTournamentModalVisible] = useState(false)
  const [loadedTournament, setLoadedTournament] = useState()

  const onNext = () => {
    props.onScheduleChange(props.currentStep + 1)
  }

  const onPrev = () => {
    props.onScheduleChange(props.currentStep - 1)
  }

  const onPreferences = () => {
    setTournamentPropertiesModalVisible(true)
  }

  const onShare = () => {
    setIsShareTournamentModalVisible(true)
    async function loadTournament () {
      const record = await getTournament(props.tournament.uuid)
      setLoadedTournament(record)
    }
    loadTournament()
  }

  const onSave = () => {
    props.onSave()
  }

  const handleOk = (tournament) => {
    handleCancel()

    props.onSave(tournament)
  }

  const handleCancel = () => {
    setTournamentPropertiesModalVisible(false)
    setIsShareTournamentModalVisible(false)
  }

  const onFinish = () => {
    props.onSave({ completed: true })
  }

  const handleShareSave = async (users) => {
    await shareTournament(props.tournament.uuid, users)
  }

  const onGoLive = async () => {
    const newTournament = _.cloneDeep(props.tournament)
    newTournament.isLive = true
    props.onSave(newTournament)
  }

  return (
    <>
      <Row gutter={[8]} style={{ marginBottom: '1em' }}>
        <Col flex='none'>
          <Tooltip title='Save'>
            <Button type='success' shape='round' icon={<SaveFilled />} onClick={onSave} size='large' />
          </Tooltip>
        </Col>
        <Col flex='none'>
          <Tooltip title='Share'>
            <Button type='lightdark' shape='round' icon={<ShareAltOutlined />} onClick={onShare} size='large' />
          </Tooltip>
        </Col>
        <Col flex='none'>
          <Tooltip title='Preferences'>
            <Button type='info' shape='round' icon={<SettingFilled />} onClick={onPreferences} size='large' />
          </Tooltip>
        </Col>
        {props.canGoLive
          ? (
            <Col flex='none'>
              <Tooltip title='Go Live'>
                <Button type='warning' shape='round' size='large' onClick={onGoLive}>Go LIVE!</Button>
              </Tooltip>
            </Col>
            )
          : ''}

        <Col flex='none'>
          <Popconfirm
            title={<div>Go back to previous round?  All inputs for this round will be cancelled.</div>}
            onConfirm={onPrev}
            okText='Accept'
            cancelText='Cancel'
            disabled={!props.canPrev}
          >
            <Button type='primary' shape='round' size='large' disabled={!props.canPrev}>
              <CaretLeftFilled />
              Prev Round
            </Button>
          </Popconfirm>
        </Col>
        {props.isDone
          ? (
            <Col flex='none'>
              <Button type='primary' shape='round' size='large' onClick={onFinish} disabled={!props.isDone}>
                Finish
                <CaretRightFilled />
              </Button>
            </Col>
            )
          : (
            <Col flex='none'>
              <Button type='primary' shape='round' size='large' onClick={onNext} disabled={!props.canNext}>
                Next Round
                <CaretRightFilled />
              </Button>
            </Col>
            )}
      </Row>
      <Modal title='Tournament Settings' width={640} visible={isTournamentPropertiesModalVisible} maskClosable={false} destroyOnClose onCancel={handleCancel} footer={null}>
        <TournamentProperties tournament={props.tournament} handleCancel={handleCancel} handleOk={handleOk} edit />
      </Modal>
      <Modal title='Share Tournament' width={640} visible={isShareTournamentModalVisible} maskClosable={false} destroyOnClose onCancel={handleCancel} footer={null}>
        <ShareTournament tournament={loadedTournament} onShare={handleShareSave} />
      </Modal>
    </>
  )
}

export default TournamentMenuBar
